<template>
  <div>
      <v-text-field
        :label="searchLabel"
        prepend-inner-icon="mdi-magnify"
        v-model="searchTerm"
        class="px-4"
        clearable
      ></v-text-field>
    <v-chip-group
      v-model="localValue"
      active-class="active-chip"
      column
      :multiple="true"
    >
      <v-chip
        v-for="(item, index) in displayedItems"
        :key="index"
        :value="item"
        elevated
      >
        {{ item }}
      </v-chip>
    </v-chip-group>
</div>
</template>

<script>
export default {
  name: 'SearchableChipGroup',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    },
    searchLabel: {
      type: String,
      default: 'Search here...'
    },
    maxDisplay: {
      type: Number,
      default: null
    },
    caseSensitive: {
      type: Boolean,
      default: false
    },
    searchKey: {
      type: String,
      default: null // For object arrays, specify which key to search
    }
  },
  data() {
    return {
      searchTerm: '',
      showAll: false,
      localValue: this.value
    }
  },
  computed: {
    filteredItems() {
      if (!this.searchTerm) return this.items;

      const searchTerm = this.caseSensitive 
        ? this.searchTerm 
        : this.searchTerm.toLowerCase();

      return this.items.filter(item => {
        const searchValue = this.searchKey ? item[this.searchKey] : item;
        const itemText = this.caseSensitive ? searchValue : searchValue.toLowerCase();
        return itemText.includes(searchTerm);
      });
    },
    displayedItems() {
      if (this.searchTerm || !this.maxDisplay || this.showAll) {
        return this.filteredItems;
      }
      return this.filteredItems.slice(0, this.maxDisplay);
    },
  },
  
  watch: {
    localValue(val) {
        this.$emit('input', val); // sync with parent when changed
    },
    value(val) {
        this.localValue = val; // sync if parent changes
    },
    searchTerm() {
      // Reset showAll when searching
      this.showAll = false;
    }
  }
}
</script>
